import React from 'react';

const Share: React.VFC = () => (
  <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3.75L7.935 4.815L6.7425 3.6225V12H5.2575V3.6225L4.065 4.815L3 3.75L6 0.75L9 3.75ZM12 7.5V15.75C12 16.575 11.325 17.25 10.5 17.25H1.5C0.6675 17.25 0 16.575 0 15.75V7.5C0 6.6675 0.6675 6 1.5 6H3.75V7.5H1.5V15.75H10.5V7.5H8.25V6H10.5C11.325 6 12 6.6675 12 7.5Z" fill="#777777" />
  </svg>
);

export default Share;
